import { useAtom } from 'jotai';

import { upgradeModalAtom } from '@/atoms/upgradeModalAtom';

export const useUpgradeModal = () => {
  const [isOpen, setIsOpen] = useAtom(upgradeModalAtom);

  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);

  return { isOpen, open, close };
};
